customElements.get('gochi-subscribe-toggle') ||
  customElements.define('gochi-subscribe-toggle', class extends HTMLElement {
    constructor() {
      super();
      this.packQuantity = this.dataset.packQuantity;
      this.switchEl = this.querySelector('.gochi-subscribe-toggle__switch');
      this.priceRow = this.querySelector('.gochi-subscribe-toggle__price-row');
      this.priceOriginalEl = this.querySelector('.gochi-subscribe-toggle__price-original');
      this.priceNewEl = this.querySelector('.gochi-subscribe-toggle__price-new');
      this.savingsEl = this.querySelector('.gochi-subscribe-toggle__savings');
      this.perCupEl = this.querySelector('.gochi-subscribe-toggle__per-cup');
      this.packCups = parseFloat(this.dataset.packCups);
      this.packShippingFee = parseFloat(this.dataset.packShippingFee) || 0;
      this.frequencySelect = this.querySelector('.gochi-subscribe-toggle__frequency-select');
      this.discountType = this.dataset.discountType;
      this.discountValue = parseFloat(this.dataset.discountValue);
      this.defaultPlanId = this.dataset.defaultSellingPlanId;
      this.hiddenInput = document.getElementById(this.dataset.sellingPlanInputId);
      this.breaksContainer = document.getElementById(this.dataset.quantityBreaksId);

      this.switchEl.addEventListener('click', (event) => {
        // Contain this click to the toggle — it must never bubble to the shared
        // quantity-breaks container, where the theme's own (unreadable/obfuscated)
        // cart-submission logic also listens for interaction and could misfire.
        event.stopPropagation();
        this.toggle();
      });
      this.switchEl.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        }
      });
      this.frequencySelect?.addEventListener('change', (event) => {
        event.stopPropagation();
        this.syncPrice();
        this.syncHiddenInput();
        this.dispatchChange();
      });
      // Every instance listens for pack changes; only the instance whose
      // pack just became selected updates the shared hidden selling_plan input.
      this.breaksContainer?.addEventListener('change', (event) => {
        if (event.target.name === 'quantity') this.syncHiddenInput();
      });

      this.syncHiddenInput();
    }

    toggle() {
      const wasChecked = this.switchEl.getAttribute('aria-checked') === 'true';
      this.switchEl.setAttribute('aria-checked', String(!wasChecked));
      this.syncPrice();
      this.syncHiddenInput();
      this.dispatchChange();
    }

    currentPlanId() {
      return this.frequencySelect ? this.frequencySelect.value : this.defaultPlanId;
    }

    isOwnPackSelected() {
      const checkedRadio = this.breaksContainer?.querySelector('input[name="quantity"]:checked');
      return !!checkedRadio && checkedRadio.value === this.packQuantity;
    }

    syncHiddenInput() {
      if (!this.hiddenInput || !this.isOwnPackSelected()) return;
      const subscribed = this.switchEl.getAttribute('aria-checked') === 'true';
      this.hiddenInput.disabled = !subscribed;
      // Always set explicitly (not just when toggled) so switching back to this
      // pack after another pack wrote a different plan id doesn't leave it stale.
      if (subscribed) {
        this.hiddenInput.value = this.currentPlanId();
      }
    }

    syncPrice() {
      // This element is nested inside the pack's own <label>, so closest('label')
      // correctly resolves here (unlike a sibling relationship elsewhere in this theme).
      const label = this.closest('label');
      const priceSource = label?.querySelector('.quantity-break__price');
      if (!priceSource) return;

      const subscribed = this.switchEl.getAttribute('aria-checked') === 'true';
      if (!subscribed) {
        this.priceRow.hidden = true;
        return;
      }

      const raw = priceSource.textContent.trim();
      const match = raw.match(/[\d.,]+/);
      if (!match) return;

      const numeric = parseFloat(match[0].replace(/,/g, ''));
      let discounted = numeric;
      if (this.discountType === 'percentage') {
        discounted = numeric * (1 - this.discountValue / 100);
      } else if (this.discountType === 'fixed_amount') {
        discounted = numeric - this.discountValue;
      } else if (this.discountType === 'price') {
        discounted = this.discountValue;
      }

      const savings = numeric - discounted;
      const decimals = match[0].includes('.') ? 2 : 0;

      this.priceOriginalEl.textContent = raw;
      this.priceNewEl.textContent = raw.replace(match[0], discounted.toFixed(decimals));
      this.savingsEl.textContent = `Save ${raw.replace(match[0], savings.toFixed(decimals))}`;

      if (this.perCupEl && this.packCups) {
        const matchIndex = raw.indexOf(match[0]);
        const prefix = raw.slice(0, matchIndex);
        const suffix = raw.slice(matchIndex + match[0].length);
        const perCup = (discounted + this.packShippingFee) / this.packCups;
        this.perCupEl.textContent = `${prefix}${perCup.toFixed(2)}${suffix}/cup`;
      }

      this.priceRow.hidden = false;
    }

    dispatchChange() {
      this.dispatchEvent(new CustomEvent('gochi-subscribe-toggle:change', { bubbles: true }));
    }
  });
